import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      paddingLeft: 0,
      paddingRight: 0,
      backgroundColor: "white",
      height: "100vh",
    },
    greeting1: {
      fontWeight: "700 !important",
      color: "#25282b",
      lineHeight: 1,
    },
    greeting2: {
      color: "#a0a4a8",
    },
    wrapper: {
      padding: "27px 16px",
    },
    searchWrapper: {
      backgroundColor: "#ffffff",
      boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.04)",
      borderRadius: 10,
      marginTop: 25,
      padding: 16,
    },
    areaSearch: {
      display: "flex",
      alignItems: "flex-start",
      cursor: "pointer",
      width: "100%",
    },
    searchIcon: {
      height: 20,
      width: 20,
    },
    calendarIcon: {
      margin: 2,
    },
    checkInOutWrapper: {
      display: "flex",
      paddingLeft: 16,
      // paddingRight: 16,
      width: "100%",
      // justifyContent: "space-between",
    },
    date: {
      color: "#a0a4a8",
      display: "block",
      fontSize: "0.68rem",
    },
    dateRange: {
      color: "#a0a4a8",
      alignItems: "center",
      display: "flex",
      padding: "0 10px",
    },
    dateRangeWrapper: {
      alignItems: "center",
      display: "flex",
    },
    buttonSearch: {
      backgroundColor: "#2f9cf1",
      textTransform: "capitalize",
      color: "#ffffff",
      fontWeight: "bold",
      marginTop: 16,
      paddingTop: 13,
      paddingBottom: 16,
      "&:hover": {
        backgroundColor: "#2880c5",
      },
    },
    buttonDefault: {
      display: "block",
      textTransform: "capitalize",
      borderRadius: 10,
      padding: 0,
      textAlign: "initial",
    },
    illustrationWrapper: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      paddingTop: 80,
    },
    bold: {
      fontWeight: "bold !important",
    },
    titleCard: {
      color: "#52575c",
      paddingBottom: 8,
    },
    totalNight: {
      position: "absolute",
      right: 0,
      paddingTop: 10,
      padding: "0 8px",
      textAlign: "center",
      backgroundColor: "#ffffff",
    },
    searchLabel: {
      width: "100%",
      display: "flex",
      borderBottom: "1px solid rgba(0,0,0,.08)",
      marginBottom: 8,
      paddingBottom: 8,
    },
    nameHotel: {
      width: "100%",
      display: "flex",
      marginBottom: 8,
    },
  })
);

export default useStyles;
